import { getPreviewGatewayPath } from "./previewGatewayPath";

export type PreviewGatewayStatus = "idle" | "pending" | "unreachable";

const PING_TIMEOUT_MS = 3000;

const listeners = new Set<() => void>();
let status: PreviewGatewayStatus = "idle";

function setStatus(next: PreviewGatewayStatus) {
  status = next;
  listeners.forEach((cb) => cb());
}

export const subscribePreviewGatewayHealth = (cb: () => void) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

export const getPreviewGatewayStatus = (): PreviewGatewayStatus => status;

// content-type, not status: an unknown preview still 200s with a fallback HTML page.
export const pingPreviewGateway = async (): Promise<void> => {
  const path = getPreviewGatewayPath();
  if (!path) {
    setStatus("idle");
    return;
  }
  setStatus("pending");
  const res = await fetch(
    `${import.meta.env.VITE_API_HOSTNAME || ""}${path}/api/query`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "{__typename}" }),
      signal: AbortSignal.timeout(PING_TIMEOUT_MS),
    },
  ).catch((err) => {
    console.error("[previewGatewayHealth] ping failed", err);
    return null;
  });
  const alive = !!res?.headers
    .get("content-type")
    ?.includes("application/json");
  setStatus(alive ? "idle" : "unreachable");
};

void pingPreviewGateway();
